import SLIDER from '../class/slider'

const [ w, d ] = [ window, document ];

const gallerySlider = new SLIDER({
  obj: '[data-plugin="slider"]',
  slickOpt: {
    autoplay: true,
    variableWidth: true,
    fade: false,
    dots: false,
    speed: 7500,
    easing: 'linear',
    cssEase: 'linear',
    autoplaySpeed: 0,
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false,
    draggable: false
  }
});

const init = () => {

  $.when( w.load['strength'] ).then(() => {
    gallerySlider.init(), gallerySlider.start();
    //スマホでタップ時にautoplayが止まる現象の対策
    $('.strength-slider').on('touchend', () => gallerySlider.start() );
  });

}

export default function STRENGTH() {
  $( init )
}